import React from 'react';
import AppView from './AppView';

export default function App() {
  return <AppView />;
}
